"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDiscord = exports.DiscordProvider = void 0;
var react_1 = __importStar(require("react"));
var Platform_1 = require("../Platform");
var useProfile_1 = __importDefault(require("../useProfile"));
var CONNECT_RETRY_INTERVAL = 15000;
var DiscordContext = (0, react_1.createContext)(null);
var sameActivity = function (first, second) {
    return (first === null || first === void 0 ? void 0 : first.state) === (second === null || second === void 0 ? void 0 : second.state) &&
        (first === null || first === void 0 ? void 0 : first.details) === (second === null || second === void 0 ? void 0 : second.details) &&
        (first === null || first === void 0 ? void 0 : first.image) === (second === null || second === void 0 ? void 0 : second.image) &&
        (first === null || first === void 0 ? void 0 : first.startTimestamp) === (second === null || second === void 0 ? void 0 : second.startTimestamp) &&
        (first === null || first === void 0 ? void 0 : first.endTimestamp) === (second === null || second === void 0 ? void 0 : second.endTimestamp);
};
var DiscordProvider = function (_a) {
    var _b;
    var children = _a.children;
    var shell = (0, Platform_1.usePlatform)().shell;
    var profile = (0, useProfile_1.default)();
    var enabled = ((_b = profile.settings) === null || _b === void 0 ? void 0 : _b.discordRpcEnabled) === true;
    var available = shell.active === true;
    var _c = (0, react_1.useState)(false), connected = _c[0], setConnected = _c[1];
    var _d = (0, react_1.useState)(null), activity = _d[0], setActivityState = _d[1];
    var sentActivity = (0, react_1.useRef)(null);
    var connectRequested = (0, react_1.useRef)(false);
    var shellRef = (0, react_1.useRef)(shell);
    shellRef.current = shell;
    (0, react_1.useEffect)(function () {
        if (!available)
            return;
        var onStatus = function (data) {
            connectRequested.current = false;
            setConnected(data.connected === true);
        };
        shellRef.current.on('discord-status', onStatus);
        return function () {
            shellRef.current.off('discord-status', onStatus);
        };
    }, [available]);
    (0, react_1.useEffect)(function () {
        if (!available) {
            connectRequested.current = false;
            setConnected(false);
            sentActivity.current = null;
            return;
        }
        if (!enabled) {
            connectRequested.current = false;
            if (connected) {
                shellRef.current.send('discord-disconnect', {});
            }
            sentActivity.current = null;
            return;
        }
        if (connected)
            return;
        var requestConnect = function () {
            if (!connectRequested.current) {
                connectRequested.current = true;
                shellRef.current.send('discord-connect', {});
            }
        };
        requestConnect();
        var interval = window.setInterval(requestConnect, CONNECT_RETRY_INTERVAL);
        return function () {
            window.clearInterval(interval);
        };
    }, [available, connected, enabled]);
    (0, react_1.useEffect)(function () {
        if (!available || !enabled || !connected)
            return;
        if (activity === null) {
            if (sentActivity.current !== null) {
                shellRef.current.send('discord-clear-activity', {});
                sentActivity.current = null;
            }
            return;
        }
        if (sameActivity(sentActivity.current, activity))
            return;
        shellRef.current.send('discord-set-activity', {
            state: activity.state,
            details: activity.details || '',
            image: activity.image || null,
            startTimestamp: activity.startTimestamp || null,
            endTimestamp: activity.endTimestamp || null,
        });
        sentActivity.current = activity;
    }, [activity, available, connected, enabled]);
    var setActivity = (0, react_1.useCallback)(function (nextActivity) {
        setActivityState(function (currentActivity) { return sameActivity(currentActivity, nextActivity) ? currentActivity : nextActivity; });
    }, []);
    var value = (0, react_1.useMemo)(function () { return ({
        available: available,
        connected: connected,
        enabled: enabled,
        setActivity: setActivity,
    }); }, [available, connected, enabled, setActivity]);
    return (react_1.default.createElement(DiscordContext.Provider, { value: value }, children));
};
exports.DiscordProvider = DiscordProvider;
var useDiscord = function () {
    var value = (0, react_1.useContext)(DiscordContext);
    if (value === null) {
        throw new Error('useDiscord must be used inside DiscordProvider');
    }
    return value;
};
exports.useDiscord = useDiscord;
